const opt = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
export default opt